import { Button } from "primereact/button";
import { useMemo } from "react";
import styles from "./style.module.scss";

const useModalLayout = (headerConfig, footerConfig) => {
    const camelCaseRegex = /^[a-zA-Z]+([A-Z][a-z]+)+$/;
    const parseClassNames = (classNames) => classNames
        .map((c) => camelCaseRegex.test(c) ? styles[c] : c)
        .join(" ");

    const header = useMemo(() => {
        const { title, className } = headerConfig;

        return <h4 className={parseClassNames([className])}>{title}</h4>;
    }, [headerConfig]);

    const footer = useMemo(() => footerConfig.buttons.map(
        ({
             classNames, label = "", onClick = () => {},
             disabled = false, loading = false
        }, id) => (
             <Button key={id}
                     className={parseClassNames(classNames)}
                     label={label}
                     onClick={onClick}
                     disabled={disabled}
                     loading={loading}
                     pt={{ root: { style: { marginRight: "12px" }}}}
            />
        )
    ), [footerConfig.buttons]);

    return { header, footer };
}

export default useModalLayout;